export const CampaignConversionGoal = {
  parent: 'Campaign',
  properties: {
    'bulk-upload-type': {
      type: 'string',
      value: 'Campaign Conversion Goal',
    },
    Id: { nullable: true },
    GoalId: {
      'bulk-upload-header': 'Goal Id',
    },
    Name: {
      'bulk-upload-header': 'Name',
    },
    SubType: {
      'bulk-upload-header': 'Sub Type',
    },
    Action: {
      'bulk-upload-header': 'Action Type',
    },
    CampaignId: {
      'bulk-upload-header': 'Parent ID',
    },
  },
};
